import { render, staticRenderFns } from "./V2X.vue?vue&type=template&id=709f1b36&scoped=true"
import script from "./V2X.vue?vue&type=script&lang=js"
export * from "./V2X.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f1b36",
  null
  
)

export default component.exports